import { useState, useEffect, useRef } from "react";
import { User } from "lucide-react";
import IconCard from "../UIComponents/IconCard";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { Avatar } from "../SVGComponents";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../redux/store";
import { getUserProfile } from "../redux/slices/authSlice";

const UserMenu = () => {
  const navigate = useNavigate();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const dispatch = useDispatch<AppDispatch>()

  const { user, error, isLoading } = useSelector((state: any) => state.auth)

  const getUserProfiles = async () => {
    await dispatch(getUserProfile())
  }
  useEffect(() => {
    getUserProfiles()
  }, [dispatch])
  const menuRef = useRef<HTMLDivElement>(null);
  const handleLogout = () => {
    localStorage.removeItem("crymadx");
    localStorage.removeItem("use");
    localStorage.removeItem("ts");
    localStorage.removeItem("summa");
    setTimeout(() => {
      toast.success("Logged out!");
    }, 500);
    // window.location.href = "/login";
    navigate("/login");
    setIsUserMenuOpen(false);
    console.log("Logged out!");
  };
  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsUserMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative cursor-pointer">
      <ToastContainer />
      {/* User Icon - Opens the Menu on Hover */}
      <div onMouseEnter={() => setIsUserMenuOpen(true)}>
        <IconCard
          Icon={user?.result?.image ? user.result.image : Avatar}
          onClick={() => navigate('/profile')}
        />

      </div>
      {isUserMenuOpen && (
        <div
          ref={menuRef}
          className="absolute right-0 p-[1px] rounded-lg bg-gradient-to-r from-[#237249] to-[#35C66B] mt-3"
        >
          <div
            className="bg-white dark:bg-[#121517] rounded-md w-[130px]"
            onMouseLeave={() => setIsUserMenuOpen(false)}
          >
            <ul className=" text-gray-700 dark:text-gray-200 space-y-1 py-2">
              <li
                onClick={() => {
                  navigate("/profile");
                  setIsUserMenuOpen(false);
                }}
                className="relative z-10 flex gap-7 hover:bg-sky-200 dark:hover:bg-gray-700 cursor-pointer text-[13px] font-[550] pl-3 py-1"
              >
                Account Setting
              </li>
              <li
                onClick={() => {
                  navigate("/support");
                  setIsUserMenuOpen(false);
                }}
                className="relative z-10 flex gap-7 hover:bg-sky-200 dark:hover:bg-gray-700 cursor-pointer text-[13px] font-[550] pl-3 py-1"
              >
                Support Ticket
              </li>
              {/* <li
                onClick={() => {navigate("/profile"); setIsUserMenuOpen(false)}}
                className="relative z-10 flex gap-7 hover:bg-sky-200 dark:hover:bg-gray-700 cursor-pointer text-[10px] font-[550] pl-3 py-1"
              >
                Edit Profile
              </li> */}
              <li
                onClick={() => {
                  handleLogout();
                  setIsUserMenuOpen(false);
                }}
                className="relative z-10 flex gap-7 hover:bg-sky-200 dark:hover:bg-gray-700 cursor-pointer text-[13px] font-[550] pl-3 py-1"
              >
                Logout
              </li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
